import { render, staticRenderFns } from "./ipadStock.vue?vue&type=template&id=e25aa4ca"
import script from "./ipadStock.vue?vue&type=script&lang=js"
export * from "./ipadStock.vue?vue&type=script&lang=js"
import style0 from "./ipadStock.vue?vue&type=style&index=0&id=e25aa4ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports